import AppContext from "@/AppContext";
import Layout from "@/components/elements/Layout";
import useAuth from "@/hooks/auth";
import dayjs from "dayjs";
import { useContext } from "react";

export default function MyPlan() {
  const { user } = useAuth({ middleware: "auth" });
  const { state } = useContext(AppContext);
  const { planSubscription, loading } = state;

  return (
    <Layout title={"My Plan"}>
      <div className='max-w-6xl px-4 mx-auto 2xl:max-w-7xl'>
        <h1 className='pt-8 text-6xl font-bold leading-tight text-white font-display'>
          My Plan
        </h1>
        <h2 className='text-white text-opacity-80'></h2>
        {planSubscription && !loading ? (
          <div className='pt-4 mt-10 -my-3 divide-y divide-dashed divide-white/10'>
            <p className='py-3'>
              Status:{" "}
              {planSubscription.has_active_subscription
                ? "Active"
                : "Not Active"}{" "}
              {planSubscription.subscription_detail.status == "trialing"
                ? "(Trial)"
                : ""}
            </p>
            <p className='py-3'>
              Plan: {planSubscription.active_product?.name}
            </p>
            <p className='py-3'>
              Effective from:{" "}
              {dayjs(planSubscription.current_period_start).format(
                "DD/MM/YYYY"
              )}
            </p>
            {planSubscription.subscription_detail.status == "trialing" ? (
              <p className='py-3'>
                Trial end:{" "}
                {dayjs
                  .unix(planSubscription.subscription_detail.trial_end)
                  .format("DD/MM/YYYY")}
              </p>
            ) : (
              <p className='py-3'>
                Active until:{" "}
                {dayjs(planSubscription.current_period_end).format(
                  "DD/MM/YYYY"
                )}
              </p>
            )}
            <p className='py-3'>
              Next billing date:{" "}
              {dayjs(planSubscription.current_period_end).format("DD/MM/YYYY")}
            </p>
            <p className='py-3'>
              Billing Frequency:{" "}
              <span>
                {planSubscription.active_plan.interval[0].toUpperCase()}
                {planSubscription.active_plan.interval.slice(1)}ly
              </span>
            </p>
            <p className='py-3'>
              Charge:{" "}
              <span className='uppercase'>
                {planSubscription.active_plan.currency}
              </span>{" "}
              {planSubscription.active_plan.amount.toLocaleString("en", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </p>
          </div>
        ) : loading ? (
          <div className='pt-4 mt-10 -my-3 divide-y divide-dashed divide-white/10'>
            Loading user subcription...
          </div>
        ) : (
          <div className='pt-4 mt-10 -my-3 divide-y divide-dashed divide-white/10'>
            No Active Subscription
          </div>
        )}
        <div></div>
      </div>
    </Layout>
  );
}
